import React from 'react';

function MultipleWorkspacesContent() {
  return (
    <>
      <p>RepoPrompt allows you to open multiple folders simultaneously, which is useful when working with related projects, referencing documentation, or including external libraries.</p>
      
      <h3>Adding Another Folder</h3>
      <ol>
        <li>With a workspace already open, locate the toolbar above the file tree panel</li>
        <li>Click the folder icon button ("<strong>Open a new folder</strong>") in this toolbar</li>
        <li>Use the system dialog to select another folder you wish to add</li>
        <li>The newly added folder will appear as another root item in the file tree panel</li>
      </ol>
      
      <h3>Use Cases for Multiple Folders</h3>
      <ul>
        <li><strong>Related Projects:</strong> Include both a frontend and backend repository</li>
        <li><strong>Documentation:</strong> Add a documentation folder alongside your code</li>
        <li><strong>External Libraries:</strong> Reference library source code while working on your project</li>
        <li><strong>Package Dependencies:</strong> Include package source code for better AI context</li>
      </ul>
      
      <div className="tip-box">
        <strong>Tip:</strong> You can select files from any of the open folders to include in your prompt, allowing you to provide the AI with a more complete picture of your codebase.
      </div>
    </>
  );
}

export default MultipleWorkspacesContent;